import qty from "../modules/qty";

const removeDuplicateNotices = notices => {
  let seen = [];
  let newNotices = notices;

  if (notices) {
    notices.forEach((notice, index) => {
      const text = notice.innerText;

      if ('undefined' === typeof seen[text]) {
        seen[text] = true;
      } else {
        newNotices.splice(index, 1);
      }
    });
  }
  return notices;
};

const showNotice = function (html_element, target) {
  if (!target) {
    target = document.querySelector('.woocommerce-notices-wrapper')
      || document.querySelector('.cart-empty').closest('.woocommerce')
      || document.querySelector('.woocommerce-cart-form');
  }
  target.prepend(html_element);
};

const updateCartTotalsDiv = html_str => {
  let totals = document.querySelector('.cart-totals');

  if (totals) {
    totals.parentNode.replaceChild(html_str, totals);

    document.body.dispatchEvent(new CustomEvent('update_cart_totals'));
  }
};

export default (html_str, preserve_notices) => {
  let parser = new DOMParser();
  let html = parser.parseFromString(html_str, "text/html");
  let newForm = html.querySelector('.woocommerce-cart-form');
  let newTotals = html.querySelector('.cart-totals');
  let notices = removeDuplicateNotices(html.querySelectorAll('.woocommerce-error, .woocommerce-message, .woocommerce-info'));
  let form = document.querySelector('.woocommerce-cart-form');
  const qtys = html.querySelectorAll('.qty');

  if (!form) {
    window.location.reload();
    return;
  }

  if (!preserve_notices) {
    let currentNotices = document.querySelectorAll('.woocommerce-error, .woocommerce-message, .woocommerce-info');

    if (currentNotices) {
      currentNotices.forEach(item => item.remove());
    }
  }

  if (!newForm) {
    if (document.querySelector('.woocommerce-checkout')) {
      window.location.reload();
      return;
    }

    let cartHtml = html.querySelector('.cart-empty').closest('.woocommerce');
    let wcDiv = document.querySelector('.woocommerce-form__contents').closest('.woocommerce');
    wcDiv.parentNode.replaceChild(cartHtml, wcDiv);

    if (notices) {
      notices.forEach(notice => showNotice(notice))
    }

    document.body.dispatchEvent(new CustomEvent('wc_cart_emptied'));
  } else {
    if (document.querySelector('.woocommerce-checkout')) {
      document.body.dispatchEvent(new CustomEvent('update_checkout'));
    }

    let updateButton = form.parentNode.replaceChild(newForm, form).querySelector('[name="update_cart"]');

    if (updateButton) {
      updateButton.setAttribute('disabled', 'true');
      updateButton.setAttribute('aria-disabled', 'true');
    }

    if (notices) {
      notices.forEach(notice => showNotice(notice));
    }

    if(qtys && qtys.length > 0) {
      qtys.forEach(q => qty($(q)));
    }

    updateCartTotalsDiv(newTotals);
  }

  document.body.dispatchEvent(new CustomEvent('update_wc_div'));
}

